import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

import acmLogo from '../assets/acm_logo.png';
import pceLogo from '../assets/pce_logo.png';

const Navbar = () => {
  const [isTeamDropdownVisible, setTeamDropdownVisible] = useState(false);
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMouseEnter = () => setTeamDropdownVisible(true);
  const handleMouseLeave = () => setTeamDropdownVisible(false);
  
  const toggleMobileMenu = () => setIsMenuOpen(!isMenuOpen);
  
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img src={acmLogo} alt="ACM Logo" className="navbar-logo" />
        <span className="navbar-title">PCE ACM</span>
      </div>

      <div 
        className={`menu-toggle ${isMenuOpen ? 'is-active' : ''}`} 
        id="mobile-menu" 
        onClick={toggleMobileMenu}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
        <li><NavLink to="/" className="nav-item" onClick={closeMenu}>Home</NavLink></li>
        <li><NavLink to="/about" className="nav-item" onClick={closeMenu}>About</NavLink></li>
        <li><NavLink to="/events" className="nav-item" onClick={closeMenu}>Events</NavLink></li>
        
        <li 
          className="nav-item-relative"
          onMouseEnter={handleMouseEnter} 
          onMouseLeave={handleMouseLeave}
        >
          <div className="nav-item team-link-container">
            Team <span className="arrow-down">▼</span>
          </div>
          
          {isTeamDropdownVisible && (
            <div className="dropdown-menu">
              <NavLink to="/team/core-team" className="dropdown-item" onClick={closeMenu}>
                Core Team
              </NavLink>
              <NavLink to="/team/web-team" className="dropdown-item" onClick={closeMenu}>
                Members
              </NavLink>
            </div>
          )}
        </li>

        <li><NavLink to="/gallery" className="nav-item" onClick={closeMenu}>Gallery</NavLink></li>
        <li><NavLink to="/contact" className="nav-item" onClick={closeMenu}>Contact Us</NavLink></li>
      </ul>

      {/* PCE Logo - Ye mobile par aksar hide kar diya jata hai ya size chota */}
      <div className="navbar-right">
        <img src={pceLogo} alt="PCE Logo" className="navbar-logo" />
      </div>
    </nav>
  );
};

export default Navbar;